import { render, staticRenderFns } from "./deliverBoxList.vue?vue&type=template&id=0d4c813f"
import script from "./deliverBoxList.vue?vue&type=script&lang=js"
export * from "./deliverBoxList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports